import {
  ByIdPayload,
  FailByIdPayload,
  OperationReducerTypes,
  PayloadAction,
  uniqueActionType
} from '@industi/ngx-common';

export const DictionaryTagDeleteActionTypes: OperationReducerTypes = {
  request: uniqueActionType('[dictionary/tag] Delete'),
  requestFail: uniqueActionType('[dictionary/tag] Delete fail'),
  requestSuccess: uniqueActionType('[dictionary/tag] Delete success'),
  requestClearErrors: uniqueActionType('[dictionary/tag] Delete clear errors'),
  requestClear: uniqueActionType('[dictionary/tag] Delete clear')
};

export class DictionaryTagDeleteAction implements PayloadAction {
  readonly type = DictionaryTagDeleteActionTypes.request;

  constructor(public payload: ByIdPayload) {
  }
}

export class DictionaryTagDeleteFailAction implements PayloadAction {
  readonly type = DictionaryTagDeleteActionTypes.requestFail;

  constructor(public payload: FailByIdPayload) {
  }
}

export class DictionaryTagDeleteSuccessAction implements PayloadAction {
  readonly type = DictionaryTagDeleteActionTypes.requestSuccess;

  constructor(public payload: ByIdPayload) {
  }
}

export class DictionaryTagDeleteClearErrorsAction implements PayloadAction {
  readonly type = DictionaryTagDeleteActionTypes.requestClearErrors;

  constructor(public payload: ByIdPayload) {
  }
}

export class DictionaryTagDeleteClearAction implements PayloadAction {
  readonly type = DictionaryTagDeleteActionTypes.requestClear;

  constructor(public payload: ByIdPayload) {
  }
}
